exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width {\r\n    width: 100%;\r\n  }\r\n  \r\n  .modal-footer {\r\n    background-color: #eeeeee;\r\n  }\r\n  \r\n  .modal-header {\r\n    color: white;\r\n    background-color: #171514;\r\n  }\r\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/modals/confirmDelete/confirmDelete.component.css
// module id = ../../../../../src/app/modals/confirmDelete/confirmDelete.component.css
// module chunks = main